import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DatePipe } from '@angular/common';
import { Tag } from '../../models/interfaces/tag.interface';
import { ModalAction } from '../../modals/modal-actions/modal-action.interface';
import { Sorts } from '../../services/pagination/models/typies/sorts.type';
import { IconComponent } from '../icon/icon.component';
import { ListContainerComponent } from '../list-container/list-container.component';
import { ModalActionsComponent } from '../../modals/modal-actions/modal-actions.component';
import { SortIconComponent } from '../sort-icon/sort-icon.component';

@Component({
  selector: 'l-tag-table',
  standalone: true,
  imports: [DatePipe, IconComponent, ListContainerComponent, ModalActionsComponent, SortIconComponent],
  templateUrl: './tag-table.component.html',
})
export class TagTableComponent {
  @Input({ required: true })
  public data: Tag[] = [];

  @Input({ required: true })
  public isLoading = false;

  @Input({ required: true })
  public getRowActions!: (tag: Tag) => ModalAction[];

  @Input()
  public limit = 10;

  @Input()
  public page = 1;

  @Input()
  public total = 0;

  @Input()
  public sort?: Sorts;

  @Output()
  public pageChange = new EventEmitter<number>();

  @Output()
  public sortChange = new EventEmitter<Sorts>();
}
